import { api } from "boot/axios";

let cachedNotificationSettings = null;
let cachedPackageList = null;
let cachedPackage = null;
let packageStatusPromise = null;

export default () => {
  //Get Notification Settings
  const getNotificationSettings = async () => {
    if (cachedNotificationSettings) {
      return cachedNotificationSettings;
    }
    try {
      const data = await api.get("/notification/settings/");
      cachedNotificationSettings = data;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Post Notification Settings
  const postNotificationSettings = async (signal) => {
    try {
      const data = await api.post(
        `/notification/settings/${signal.id}`,
        signal
      );
      cachedNotificationSettings = null;

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //User Feature
  const userFeature = async () => {
    try {
      const data = await api.get("/membership/package/add-ons/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Get User Feature
  const getUserFeature = async () => {
    try {
      const data = await api.get("/membership/user-feature/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Selected stocks
  const selectedStocks = async () => {
    try {
      const data = await api.get("/membership/package/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Package Details
  const packageDetails = async () => {
    if (cachedPackageList) {
      return cachedPackageList;
    }
    try {
      const data = await api.get("/membership/package/list/");
      cachedPackageList = data;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get User Package Detail
  const getPackage = async () => {
    try {
      const data = await api.get("/membership/package/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // Get MySignals
  const getMySignals = async () => {
    try {
      const data = await api.get("/membership/package/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Validate Promo-Code
  const checkPromoValidation = async (code) => {
    try {
      const data = await api.get(`/membership/verify/?promo-code=${code}`);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post User Package
  const postPackage = async (selectedStocks) => {
    try {
      const data = await api.post("/membership/package/", {
        stocks: [selectedStocks.model],
        buy_target: selectedStocks.buy_target,
        sell_target: selectedStocks.sell_target,
      });
      cachedPackage = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Delete Stock
  const deleteStock = async (deleteStockModel) => {
    try {
      const data = await api.delete(
        `/membership/package/?stocks=${deleteStockModel}`
      );
      cachedPackage = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Sync MeroWorth
  const syncMeroWorth = async () => {
    try {
      const data = await api.post(`/membership/sync/`);
      cachedPackage = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //  Get current package status
  const getPackageStatus = async () => {
    if (cachedPackage) {
      return cachedPackage;
    }
    if (packageStatusPromise) {
      return packageStatusPromise;
    }
    try {
      packageStatusPromise = api.get(`/membership/package/status/`);
      const data = await packageStatusPromise;
      cachedPackage = data;
      packageStatusPromise = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // Get MySignals with Target
  const getMySignalswithTarget = async () => {
    try {
      const data = await api.get("/membership/target/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // Patch MySignals with Target
  const UpdateMySignalswithTarget = async (signalDetail) => {
    try {
      const data = await api.patch(`/membership/target/${signalDetail.id}`, {
        buy_target: parseInt(signalDetail.buy_target),
        sell_target: parseInt(signalDetail.sell_target),
        send_notification: signalDetail.send_notification,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // Get Referral Count
  const getReferralCount = async () => {
    try {
      const data = Object;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // Get Referral Eligibility
  const getReferralEligibility = async () => {
    try {
      const data = Object;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // Get Referral Status
  const getReferralStatus = async () => {
    try {
      const data = Object;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Referral Number

  const postReferralNumber = async (referralNumber) => {
    try {
      const data = Object;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //activate Package By referral Count

  const activatePackageByReferralCount = async (package_id) => {
    try {
      const data = Object;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Referral Details List
  const referralDetailsList = async () => {
    try {
      const data = Object;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const clearMembershipCache = () => {
    cachedNotificationSettings = null;
    cachedPackageList = null;
    cachedPackage = null;
  };

  return {
    packageDetails,
    getPackage,
    checkPromoValidation,
    postPackage,
    deleteStock,
    syncMeroWorth,

    getMySignals,
    getMySignalswithTarget,
    UpdateMySignalswithTarget,
    selectedStocks,
    getPackageStatus,
    getReferralEligibility,
    getReferralCount,
    postReferralNumber,
    getReferralStatus,
    activatePackageByReferralCount,
    referralDetailsList,

    userFeature,
    getUserFeature,

    getNotificationSettings,
    postNotificationSettings,
    clearMembershipCache,
  };
};
